import { toast } from "react-toastify";

// Shows whatever the server actually said.
//
// The API answers in two shapes. A failed validation sends
// { errors: [{ msg }] }, which is what this app was written against. Every
// refusal the escrow flow makes sends a sentence instead: "Insufficient
// balance: please add money to your account", "Task already paid or not
// completed", "Fast support is already paid for this task". Reaching for
// .errors on one of those reads undefined and then throws on .forEach, inside
// a catch block, so the reader was told nothing at all and the reason they
// could not pay stayed on the server.
export const showApiError = (err, fallback = "Something went wrong, please try again.") => {
  const data = err?.response?.data;
  if (Array.isArray(data?.errors)) {
    data.errors.forEach((error) => toast.error(error.msg));
    return;
  }
  if (typeof data === "string" && data.trim()) {
    toast.error(data);
    return;
  }
  if (typeof data?.message === "string" && data.message.trim()) {
    toast.error(data.message);
    return;
  }
  toast.error(fallback);
};

export default showApiError;
